module.exports = __webpack_public_path__ + "img/in-icon1.ca46b659.svg";